import { guestApiBaseUrl } from './apiBaseUrl';
import { useAuthedImage } from './ui/useAuthedImage';

interface Props {
  portalBrandName?: string | null;
  portalLogoUrl?: string | null;
  token?: string;
  fallbackLabel: string;
}

export function GuestPortalBrand({ portalBrandName, portalLogoUrl, token, fallbackLabel }: Props) {
  const label = portalBrandName?.trim() || fallbackLabel;
  const absoluteLogoUrl = portalLogoUrl
    ? `${guestApiBaseUrl}${portalLogoUrl.startsWith('/') ? '' : '/'}${portalLogoUrl}`
    : null;
  const src = useAuthedImage(absoluteLogoUrl, token);

  if (!src) {
    return (
      <span
        className="font-display text-fg block max-w-52 truncate text-sm font-semibold tracking-[0.08em]"
        title={label}
        aria-label={label}
      >
        {label}
      </span>
    );
  }

  return (
    <span className="flex min-w-0 items-center gap-2.5" aria-label={label}>
      <img src={src} alt={label} className="max-h-8 max-w-28 shrink-0 object-contain" />
      {portalBrandName && (
        <span className="font-display text-fg min-w-0 truncate text-sm font-semibold">
          {portalBrandName}
        </span>
      )}
    </span>
  );
}
